import { render, staticRenderFns } from "./LeftComponent.vue?vue&type=template&id=4ab21c0c"
import script from "./LeftComponent.vue?vue&type=script&lang=js"
export * from "./LeftComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports